import * as $ from 'jquery';
import { apiBaseUrlUser } from "../../../constants/url.constant";
import { DefaultService } from "../../common/services/DefaultService";
import { CustomerInvoiceChangeModel } from "../models/InvoiceModel";

export class InvoiceService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/invoice`;

    public RouteGet = (id: string) => `${this.baseUrl}/get/${id}`;
    public get(id: string): JQueryPromise<any> {
        return $.ajax(this.RouteGet(id), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetList = () => `${this.baseUrl}/getList`;
    public getList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetList(), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteGetStatusList = () => `${this.baseUrl}/getStatusList`;
    public getStatusList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetStatusList(), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteChangeDeliveryInfo = () => `${this.baseUrl}/changeDeliveryInfo`;
    public changeDeliveryInfo(model: CustomerInvoiceChangeModel): JQueryPromise<any> {
        return $.ajax(this.RouteChangeDeliveryInfo(), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }
}